import React from 'react';
import { Button, Empty } from 'antd';
import './index.less';

export type EmptyType = 'noData' | 'searchEmpty' | 'error' | 'networkError' | 'custom';

interface EmptyStateProps {
  type?: EmptyType;
  title?: string;
  description?: string;
  image?: string;
  showAction?: boolean;
  actionText?: string;
  onAction?: () => void;
  actionType?: 'primary' | 'default';
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  type = 'noData',
  title,
  description,
  image,
  showAction = true,
  actionText = '新建',
  onAction,
  actionType = 'primary',
  className = '',
}) => {
  // 根据类型获取默认配置
  const getDefaultConfig = () => {
    switch (type) {
      case 'noData':
        return {
          title: title || '暂无数据',
          description: description || '',
          image: image || undefined,
          actionText: actionText || '',
        };
      case 'searchEmpty':
        return {
          title: title || '暂无搜索结果',
          description: description || '',
          image: image || undefined,
          actionText: actionText || '',
        };
      case 'error':
        return {
          title: title || '出错了',
          description: description || '数据加载失败，请稍后重试',
          image: image || undefined,
          actionText: actionText || '重新加载',
        };
      case 'networkError':
        return {
          title: title || '网络连接失败',
          description: description || '请检查网络连接后重试',
          image: image || undefined,
          actionText: actionText || '重新加载',
        };
      case 'custom':
        return {
          title: title || '暂无内容',
          description: description || '',
          image: image || undefined,
          actionText: actionText || '操作',
        };
      default:
        return {
          title: title || '暂无数据',
          description: description || '',
          image: image || undefined,
          actionText: actionText || '操作',
        };
    }
  };

  const config = getDefaultConfig();

  return (
    <div className={`empty-state ${className}`}>
      <Empty
        image={config.image}
        styles={{
          image: {
            height: 120,
          },
        }}
        description={
          <div className="empty-description">
            <div className="empty-title">{config.title}</div>
            {config.description && (
              <div className="empty-subtitle">{config.description}</div>
            )}
          </div>
        }
      >
        {showAction && onAction && (
          <Button 
            type={actionType} 
            onClick={onAction}
            className="empty-action"
          >
            {config.actionText}
          </Button>
        )}
      </Empty>
    </div>
  );
};

export default EmptyState;